import { SERVER_API } from "../../../config.json";


function* GetDataConfirmFromApi(DataPlan) {
    const response = yield fetch(SERVER_API + "api/Action/PressActionByMail", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(DataPlan)
    });
    if (response.status === 200) {
        const Data = yield response.json();
        if (Data.status === "OK") {
            return yield Data.data;
        }
    }
    else{
        return yield {};
    }
}
function* GetDataPlanHandleStepFromApi(DataPlanStep) {
    const response = yield fetch(SERVER_API + "api/PlanTypeConfiguration/GetConfigWhenRejectByMain", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(DataPlanStep)
    });
    if (response.status === 200) {
        const Data = yield response.json();
        if (Data.status === "OK") {
            return yield Data.data;
        }
    }
    else{
        return yield {};
    }
}
//CreateFuntionHygen
export const Api = {
    GetDataConfirmFromApi,
    GetDataPlanHandleStepFromApi
    //ExportFuntionHygen
}
